import * as R from "ramda";
import { toast } from 'react-toastify';
import BackofficeUser from '../../constants/models/backofficeUser';
import * as ActionTypes from '../../constants/actiontypes/backoffice/user';
import * as ActionTypesUser from '../../constants/actiontypes/user';
import * as ActionTypesFacilita from '../../constants/actiontypes/facilita/deathDeclaration';
import * as PartnerActionTypes from '../../constants/actiontypes/partner/partner';
import * as PartnerLoadings from '../../constants/loadings/partner/partner';
import * as Loadings from '../../constants/loadings/user';
import * as LoadingsFacilita from '../../constants/loadings/facilita/deathDeclaration';
import Service from '../../constants/models/service';
import ServiceData from '../../constants/models/serviceData';
import Address from '../../constants/models/address';
import Referent from '../../constants/models/referent';
import Letter from '../../constants/models/facilita/letter';
import DocumentFile from '../../constants/models/documentFile';
import DeathDeclaration from '../../constants/models/facilita/deathDeclaration';
import toastConf from '../../utils/toasterConfiguration';
import * as TextUser from '../../constants/toasterText/user';
import * as ToasterText from '../../constants/toasterText/user';
import InvoicePartner from "../../constants/models/invoicePartner";
import Partner from "../../constants/models/backoffice/partner";

let initialState = {
    isLoading: [],
    user: undefined,
    address: undefined,
    referents: [],
    services: [],
    documents: [],
    serviceDatas: [],
    userLetters: [],
    documents: [],
    declaration: undefined,
    message: '',
    profilePicture: undefined,
    isDeletingReferent: false,
    stripeClientSecret: undefined,
    signupStep4Success: false,
    deathDate: undefined,
    invoices: [],
    etablissement: undefined,
    partner: undefined
};


const UserBackOfficeDetailReducer = (state = initialState, action) => {

    switch (action.type) {
        case ActionTypes.RESET_BACKOFFICER_USER_STATE:
            state.isLoading = [];
            state.connectionTypes = [];
            state.documents = [];
            state.user = undefined;
            state.address = undefined;
            state.declaration = undefined;
            state.referents = [];
            state.services = [];
            state.userLetters = [];
            state.serviceDatas = [];
            state.isDeletingReferent = false;
            state.deathDate = undefined;
            state.invoices = [];
            state.etablissement = undefined;
            state.partner = undefined;
            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCH_USER)) {
                state.isLoading.push(Loadings.FETCH_USER);
            }
            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_USER);

            if (Array.isArray(action.data)) {
                state.user = new BackofficeUser(action.data[0]);
            }
            else {
                state.user = new BackofficeUser(action.data);
            }
            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_USER);
            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_INVOICES_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCH_INVOICES)) {
                state.isLoading.push(Loadings.FETCH_INVOICES);
            }
            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_INVOICES_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_INVOICES);
            state.invoices = action.data.items.map(invoice => new InvoicePartner(invoice));

            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_INVOICES_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_INVOICES);
            return { ...state };

        case ActionTypes.DELETE_BACKOFFICE_USER_REQUEST:
            // if (!state.isLoading.includes(Loadings.FETCH_USER)) {
            //     state.isLoading.push(Loadings.FETCH_USER);
            // }
            return { ...state };

        case ActionTypes.DELETE_BACKOFFICE_USER_SUCCESS:
            state.user.status = "closed";
            return { ...state };

        case ActionTypes.DELETE_BACKOFFICE_USER_FAILURE:
            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_SERVICES_REQUEST:
            if (!state.isLoading.includes(`${Loadings.FETCH_SERVICES}`)) {
                state.isLoading.push(`${Loadings.FETCH_SERVICES}`);
            }
            return { ...state };

        case ActionTypes.FETCH_BACKOFFICE_USER_SERVICES_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCH_SERVICES);

            if (action.data.length > 0) {
                action.data.forEach(s => {
                    if (state.services.findIndex(sv => sv.id === s.id) === -1) {
                        state.services.push(new Service(s));
                    }
                });
            }
            return { ...state };

        case ActionTypesFacilita.FETCH_USER_SERVICES_DATA_REQUEST:
            if (!state.isLoading.includes(LoadingsFacilita.FETCHING_USER_SERVICES_DATA)) {
                state.isLoading.push(LoadingsFacilita.FETCHING_USER_SERVICES_DATA);
            }
            return { ...state };

        case ActionTypesFacilita.FETCH_USER_SERVICES_DATA_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.FETCHING_USER_SERVICES_DATA);
            state.serviceDatas = action.data;
            return { ...state };

        case ActionTypesFacilita.FETCH_USER_SERVICES_DATA_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.FETCHING_USER_SERVICES_DATA);
            return { ...state };

        case ActionTypesUser.FETCH_USER_ADDRESS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_USER_ADDRESSES)) {
                state.isLoading.push(Loadings.FETCHING_USER_ADDRESSES);
            }
            return { ...state };

        case ActionTypesUser.FETCH_USER_ADDRESS_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_USER_ADDRESSES);
            if (action.data.length > 0 && action.data[0] !== undefined) {
                state.address = new Address(action.data[0]);
            }
            return { ...state };

        case ActionTypesUser.FETCH_REPRESENTATIVES_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCH_REPRESENTATIVES)) {
                state.isLoading.push(Loadings.FETCH_REPRESENTATIVES);
            }
            return { ...state };

        case ActionTypesUser.FETCH_REPRESENTATIVES_SUCCESS:
            state.referents = action.data.map(r => new Referent(r));
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCH_REPRESENTATIVES);
            return { ...state };

        case ActionTypesUser.FETCH_REPRESENTATIVES_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCH_REPRESENTATIVES);
            return { ...state };

        case ActionTypesFacilita.FETCH_USER_LETTERS_REQUEST:
            if (!state.isLoading.includes(LoadingsFacilita.FETCHING_USER_LETTERS + "_" + action.userId)) {
                state.isLoading.push(LoadingsFacilita.FETCHING_USER_LETTERS + "_" + action.userId);
            }
            return { ...state };

        case ActionTypesFacilita.FETCH_USER_LETTERS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.FETCHING_USER_LETTERS + "_" + action.userId);
            return { ...state };

        case ActionTypesFacilita.FETCH_USER_LETTERS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.FETCHING_USER_LETTERS + "_" + action.userId);
            state.userLetters = action.letters.map(l => new Letter(l));
            return { ...state };

        case ActionTypesUser.FETCH_DOCUMENTS_SUCCESS:
            if (action.data !== undefined && action.data.length > 0) {
                state.documents = action.data.map(d => new DocumentFile(d));
            }
            return { ...state };

        case ActionTypesFacilita.CREATE_DECLARATION_REQUEST:
            if (!state.isLoading.includes(LoadingsFacilita.CREATING_DECLARATION)) {
                state.isLoading.push(LoadingsFacilita.CREATING_DECLARATION);
            }
            return { ...state };

        case ActionTypesFacilita.CREATE_DECLARATION_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.CREATING_DECLARATION);

            state.declaration = new DeathDeclaration(action.data);
            return { ...state };

        case ActionTypesFacilita.CREATE_DECLARATION_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.CREATING_DECLARATION);
            return { ...state };

        case ActionTypesFacilita.FETCH_DECLARATION_REQUEST:
            if (!state.isLoading.includes(LoadingsFacilita.FETCHING_DECLARATION)) {
                state.isLoading.push(LoadingsFacilita.FETCHING_DECLARATION);
            }
            return { ...state };

        case ActionTypesFacilita.FETCH_DECLARATION_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.FETCHING_DECLARATION);
            if(!R.isNil(action.data.deathDate)){
                state.deathDate = new Date(action.data.deathDate);
            }
            state.declaration = action.data;
            return { ...state };

        case ActionTypesFacilita.FETCH_DECLARATION_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.FETCHING_DECLARATION);
            return { ...state };

        case ActionTypesFacilita.REPRESENTATIVE_INVITATION_FAILURE:
            if (!state.isLoading.includes(LoadingsFacilita.INVITING_REPRESENTATIVE)) {
                state.isLoading.push(LoadingsFacilita.INVITING_REPRESENTATIVE);
            }
            return { ...state };

        case ActionTypesFacilita.REPRESENTATIVE_INVITATION_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.INVITING_REPRESENTATIVE);
            toast.success(ToasterText.inviteRepresentativeSuccess, toastConf);

            return { ...state };

        case ActionTypesFacilita.REPRESENTATIVE_INVITATION_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== LoadingsFacilita.INVITING_REPRESENTATIVE);
            toast.error(ToasterText.inviteRepresentativeFailed, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_BACKOFFICE_USER_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATE_USER)) {
                state.isLoading = state.isLoading.concat(Loadings.UPDATE_USER);
            }
            return { ...state };

        case ActionTypes.UPDATE_BACKOFFICE_USER_SUCCESS:
            state.user = { ...state.user, isEnabled: false };

            state.isLoading = state.isLoading.filter(l => l !== Loadings.UPDATE_USER);
            toast.success(TextUser.dataUpdatedSuccess, toastConf);
            return { ...state };

        case ActionTypes.UPDATE_BACKOFFICE_USER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.UPDATE_USER);
            toast.error(TextUser.dataUpdateFailed, toastConf);
            return { ...state };

        case PartnerActionTypes.FETCH_PARTNER_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_PARTNER)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_PARTNER);
            }
            return { ...state };

        case PartnerActionTypes.FETCH_PARTNER_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_PARTNER);
            state.partner = new Partner(action.data);
            return { ...state };


        case PartnerActionTypes.FETCH_PARTNER_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_PARTNER);
            return { ...state };

        case PartnerActionTypes.FETCH_ETABLISSEMENT_REQUEST:
            if (!state.isLoading.includes(PartnerLoadings.FETCHING_ETABLISSEMENT)) {
                state.isLoading = state.isLoading.concat(PartnerLoadings.FETCHING_ETABLISSEMENT);
            }
            return { ...state };

        case PartnerActionTypes.FETCH_ETABLISSEMENT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ETABLISSEMENT);
            state.etablissement = action.data;
            return { ...state };

        case PartnerActionTypes.FETCH_ETABLISSEMENT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== PartnerLoadings.FETCHING_ETABLISSEMENT);
            return { ...state };

        case ActionTypes.GENERATE_PRINT_REQUEST:
            if (!state.isLoading.includes(Loadings.GENERATING_PRINT)) {
                state.isLoading = state.isLoading.concat(Loadings.GENERATING_PRINT);
            }
            return { ...state };

        case ActionTypes.GENERATE_PRINT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.GENERATING_PRINT);
            state.etablissement = action.data;
            return { ...state };

        case ActionTypes.GENERATE_PRINT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.GENERATING_PRINT);
            return { ...state };

        default:
            return state;

    }
};

export default UserBackOfficeDetailReducer;